import ajax from '@utils/ajax'

/**
 * 
 * @module 用户申请开票管理
 */

// 查询列表
export const getList = params => ajax.post('financeManage/queryPaymentOrderInformation', params)

// 导出
export const downloadDetailsApi = params => ajax.post('financeManage/exportD1CapitalList', params)


